import Box from '@mui/material/Box';

import type { LoadingFailureMessage } from '../utils/loading-failure-message.util';

import { NoData } from './Illustrations/NoData';
import { MessageList } from './MessageList';
import { SplashScreen } from './SplashScreen';

interface Props {
  readonly failure: LoadingFailureMessage;
  readonly onRetry: () => void;
}

export const LoadingFailure = ({ failure, onRetry }: Readonly<Props>) => (
  <SplashScreen
    action={{ label: 'Réessayer', onClick: onRetry }}
    illustration={<NoData />}
    message={
      <>
        {!!failure.title && (
          <Box component="strong" sx={{ display: 'block' }}>
            {failure.title}
          </Box>
        )}
        <MessageList messages={failure.messages} />
      </>
    }
  />
);
